import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { IGeoConstraint } from "@faire/web-api--source/faire/geo/IGeoConstraint";
import { BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES } from "@faire/web-api--source/indigofair/settings/BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES";

export const getSettingBrandAdditionalSupportedGeographies =
  (): IGeoConstraint[] =>
    getSettingValueWithoutAssignment(
      BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES,
      []
    );
